<template>
  <div class="color-sample n2-east">
    <section>
      <p class="small-text">
        平歳三年 十二月三十 一日 没
      </p>
    </section>
    <section class="flex center grow column">
      <p class="box default-text">
        武皇嘯厚大禅門
      </p>
      <p class="box default-text">
        武皇嘯厚大禅門
      </p>
    </section>
    <section>
      <p class="small-text">
        平歳三年 十二月三十 一日 没
      </p>
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";
</style>
